export default "__VITE_ASSET__CX8MXAZg__"